import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  section: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '80px 50px',
    margin: '0 auto',
    textAlign: 'justify',
    background: "linear-gradient(90deg, #1356DA 25%, #115CDB 40%, #02A7EF 55%, #00B8F4 100%)",
    backgroundSize: '', // Asegura que la imagen cubra todo el contenedor
    backgroundPosition: "center", // Centra la imagen
    backgroundRepeat: "no-repeat", // Evita que la imagen se repita
  },
  textContainer: {
    width: '60%',
    display: 'flex',
    alignItems: 'center',
    "@media (max-width: 1540px)": {
      width: '70%'
    },
    "@media (max-width: 1280px)": {
      width: '80%'
    },
    "@media (max-width: 1023px)": {
      width: '90%'
    },
    "@media (max-width: 768px)": {
      width: '95%',
      display: 'block'
    },
  },
  itemContainerLeft: {
    "@media (min-width: 769px)": {
      width: '65%'
    },
  },
  itemContainerRight: {
    display: 'none',
    "@media (min-width: 769px)": {
      width: '35%',
      display: 'block'
    },
  },
  imgTop: {
    display: 'none',
    "@media (max-width: 768px)": {
      display: 'block',
      textAlign: 'center'
    },
  },
  heading: {
    marginBottom: '20px',
    color: '#ffffff',
    fontSize: '48px',
    textAlign: 'left',
    marginTop: '0px',
    "@media (max-width: 1540px)": {
      fontSize: '46px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '44px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '42px',
    },
    "@media (max-width: 768px)": {
      fontSize: '40px',
    },
    "@media (max-width: 600px)": {
      fontSize: '38px',
    },
    "@media (max-width: 480px)": {
      fontSize: '36px',
    },
    "@media (max-width: 400px)": {
      fontSize: '34px',
    },
  },
  paragraph: {
    color: '#ffffff',
    fontSize: '28px',
    /* textAlign: 'left', */
    "@media (max-width: 1540px)": {
      fontSize: '26px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '24px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '22px',
    },
    "@media (max-width: 768px)": {
      textAlign: 'left',
      fontSize: '20px'
    },
    "@media (max-width: 600px)": {
      fontSize: '18px',
    },
  },
  imageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  button: {
    marginTop: '20px',
    textTransform: 'none !important',
    color: '#1356DA !important',
    fontWeight: 'bold !important',
    backgroundColor: 'white !important',
    fontSize: '20px !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
      color: 'white !important',
      border: '1px solid white'
    },
    "@media (max-width: 1540px)": {
      fontSize: '18px !important',
    },
    "@media (max-width: 1280px)": {
      fontSize: '17px !important',
    },
    "@media (max-width: 1023px)": {
      fontSize: '16px !important',
    },
    "@media (max-width: 768px)": {
      fontSize: '15px !important',
    },
    "@media (max-width: 600px)": {
      fontSize: '14px !important',
    },
    "@media (max-width: 480px)": {
      fontSize: '13px !important',
    },
    "@media (max-width: 400px)": {
      fontSize: '12px !important',
    },
  },
  cardsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '30px',
    gap: '20px',
  },
  card: {
    width: '22%',
    background: 'linear-gradient(142deg, rgba(196,233,241,1) 1%, rgba(250,250,250,1) 25%, rgba(250,250,250,1) 75%, rgba(196,233,241,1) 100%)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    textAlign: 'center',
    borderBottom: '10px solid #1356DA', // Borde solo en la parte inferior
    borderRadius: '8px', // Bordes redondeados en todo el card
  },
  cardImage: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '10px', // Espacio debajo de la imagen
    borderRadius: '8px',
  },
  cardContent: {
    color: '#243C53',
    textAlign: 'start',
  },
  // Consulta de medios para pantallas de 1200px o menos
  '@media (max-width: 1200px)': {
    cardsContainer: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    card: {
      width: '80%',
      marginBottom: '20px',
    },
  },
});

export default useStyles;